module.exports = __webpack_public_path__ + "img/monkey_king.132c7553.png";